import {CreateQualityControlFormField} from "../types/create-quality-control-form-field.types";
import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export const createQualityControlFormFields: Array<CreateQualityControlFormField> = [
  {
    fieldName: 'nmId',
    label: 'Артикул Wildberries',
    type: 'select'
  },
  {
    fieldName: 'sku',
    label: 'Артикул Ozon',
    type: 'select'
  },
  {
    fieldName: 'mainPhotoQuality',
    label: 'Оценка главного фото',
    type: 'select'
  },
  {
    fieldName: 'listingQuality',
    label: 'Оценка листинга',
    type: 'select'
  },
  {
    fieldName: 'richContentQuality',
    label: 'Оценка рич-контента',
    type: 'select'
  },
  {
    fieldName: 'photoMarksQuality',
    label: 'Оценка отметок на фото',
    type: 'select'
  },
  {
    fieldName: 'videoQuality',
    label: 'Оценка видео',
    type: 'select'
  },
  {
    fieldName: 'sellerRecommended',
    label: 'Продавец рекомендует',
    type: 'select'
  }
]

export const atLeastOneRequired = (a: string, b: string): ValidatorFn => {
  return (group: AbstractControl): ValidationErrors | null => {
    const aValue = group.get(a)?.value;
    const bValue = group.get(b)?.value;

    const hasA = aValue !== null && aValue !== undefined && String(aValue).trim() !== '';
    const hasB = bValue !== null && bValue !== undefined && String(bValue).trim() !== '';

    return hasA || hasB ? null : { atLeastOneRequired: true };
  };
};
